<template>
  <div class="home" ref="home">
    <!-- <Banner /> -->

    <div class="bg-wrap">
      <img v-lazy="bg"/>
    </div>

    <div class="main-wrap">
      <div class="main-title">今日推荐</div>
      <div class="main-banner">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(image, index) in bannerList" :key="index">
            <img v-lazy="image"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="main-info">
        <div class="info-name">
          {{ goodsInfo.goodsName }}
        </div>
        <div class="info-price">
          <span>￥{{ goodsInfo.price }} </span>

          <span> </span>
        </div>
      </div>

      <div class="main-select">
        <div class="select-item">
          <span class="label">规格</span>
          <span class="label">{{ goodsInfo.specStr }}</span>
        </div>
      </div>


      <div class="main-goods">
        <div class="goods-text" v-html="goodsInfo.content"></div>
      </div>
    </div>
    <div class="main-btn">
      <img class="my_btn more-goods" :src="moreBtn" @click="goBdFgShops" alt="更多好物"/>
      <img class="my_btn now-bug" :src="byBtn" @click="onRushBuy" alt="立即抢购"/>
    </div>
    <Footer :goodsInfo="goodsInfo"/>
  </div>
</template>

<script>
import axios from "axios";
import Footer from "../home/components/Footer.vue";

import {getGoodsInfo} from "@/api/home";
/*实体商品分享页面*/
export default {
  data() {
    return {
      moreBtn: require("@/assets/more-goods.png"),
      byBtn: require("@/assets/now-buy.png"),
      bannerList: [require("@/assets/banner.jpg")],
      bg: require("@/assets/nbg.jpg"),
      timestamp: "",
      nonceStr: "",
      signature: "",
      goodsInfo: {},
      contentURL: ""
    };
  },
  components: {
    Footer
  },
  methods: {
    finish() {
      this.isTimeOver = true;
    },
    goBdFgShops() {
      window.location.href =
          "https://nthh.media.hugd.com/html/guidePage/index.html?code=bdmdfgd"

    },
    onRushBuy() {
      window.location.href =
          "https://nthh.media.hugd.com/html/guidePage/index.html?code=EightSale";
    },


    async getGoodsInfo() {
      const {data: res} = await getGoodsInfo();

      console.log(res);
      if (res.code === 200) {
        this.goodsInfo = res.data;
        this.bannerList = res.data.bannerList.split("|")||[];
        setTimeout(() => {
          let imgList = document.querySelectorAll(".goods-text img")
          imgList.forEach(item => {
            item.style.width = '100%'
            item.style.height = '100%'
          })
        }, 500)
      }
    },

    async getRoot() {
      const {data: res} = await axios.get(
          "https://nthhserve.hugd.com/pledgeManage/getWecatTicketAndSaveNew?url=http://prod-app-frontend.zhijianmedia.cn/flash-sale/#/share"
      );
      console.log(res);
      if (res.code === 200) {
        if (res.data) {
          this.timestamp = res.data.timestamp;
          this.nonceStr = res.data.noncestr;
          this.signature = res.data.sign;
          wx.config({
            debug: false,
            appId: "wxc0ae0375c6f4a068", // 必填，公众号的唯一标识
            timestamp: this.timestamp, // 必填，生成签名的时间戳
            nonceStr: this.nonceStr, // 必填，生成签名的随机串
            signature: this.signature, // 必填，签名
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
          });

          let that = this;

          wx.ready(function () {
            wx.onMenuShareTimeline({
              title: that.goodsInfo.shareTitle,
              link: "http://prod-app-frontend.zhijianmedia.cn/flash-sale/#/share", // 分享链接
              imgUrl:
                  "http://flash-sale-end.zhijianmedia.cn/img/nbg.4d1fbae5.jpg"
            });

            wx.onMenuShareAppMessage({
              title: that.goodsInfo.shareTitle,
              desc: "等你来参与", // 分享描述
              link: "http://prod-app-frontend.zhijianmedia.cn/flash-sale/#/share", // 分享链接，该链接域名必须与当前企业的可信域名一致
              imgUrl:
                  "http://flash-sale-end.zhijianmedia.cn/img/nbg.4d1fbae5.jpg", // 分享图标
              type: "", // 分享类型,music、video或link，不填默认为link
              dataUrl: "" // 如果type是music或video，则要提供数据链接，默认为空
            });
            // document.getElementById("video").play();
          });
        }
      }
    }
  },
  mounted() {
    this.getRoot();
  },

  created() {
    this.getGoodsInfo();
  }
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: calc(100vh - 20px);
  overflow-y: scroll;

  background: #fff;
  // background: chocolate;
  .main-btn {
    position: absolute;
    right: -1px;
    bottom: calc(100vh - 465px);
    display: flex;
    flex-direction: column;
    z-index: 9999999;

    .my_btn {
      height: 55.6666666667px;
      width: 52.3333333333px;
      margin-top: 5px;
    }

  }

  .bg-wrap {
    width: 100%;

    img {
      width: 100%;
      height: 156px;
      // height: 214px;
      // border-radius: 4px;
    }
  }

  .main-wrap {
    // z-index: 99;
    margin-top: -10px;
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    // box-shadow: @shadow;

    .main-title {
      font-size: 16px;
      padding: 4px;

      color: #ff991d;
    }

    .main-banner {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;

      img {
        border-radius: 10px;
        width: 100%;
        height: 100%;
        // border-radius: 4px;
      }
    }

    .main-info {
      margin-bottom: 10px;

      .info-name {
        font-size: 16px;
        padding: 4px;
      }

      .info-price {
        span:nth-child(1) {
          color: #ff991d;
          font-size: 20px;
        }

        span:nth-child(2) {
          color: #666;
        }
      }
    }

    .main-select {
      margin-bottom: 10px;
      background: #f9f9f9;
      padding: 10px;

      .select-item {
        display: flex;

        justify-content: space-between;
        align-items: center;

        .label {
          color: #666;
        }
      }

      // .select-item:nth-child(1) {
      //   margin-bottom: 15px;
      // }
    }


    .main-goods {
      .goods-text {
        /deep/ img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        /deep/ video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        margin-bottom: 10px;

        /deep/ p {
          color: #666;

          line-height: 28px;
        }

        P {
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
        }
      }

      .goods-img {
        margin: 10px 0;

        img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }
      }
    }

    .card-header {
      display: flex;

      justify-content: space-between;
      align-items: center;

      .ecard {
        padding: 4px 10px;
        border-radius: 10px 0 0 10px;
        background: #569aff;
        color: #fff;
        margin-right: -10px;
      }

      // flex-direction: column;
    }
  }
}

.grey {
  background: #eee;
}

.home::-webkit-scrollbar {
  display: none;
}
</style>
